import React from 'react';
import { Link } from 'react-router-dom';

import { copyToClipboard } from '../../../helpers/clipboardHelper';
import { slugify } from '../../../utils/slugify';

const renderAddressOrCounty = (course) => {
  if (course.course_address) {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      course.course_name + ' golf course',
    )}`;
    return (
      <a
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-indigo-100 hover:bg-indigo-600 hover:text-white no-underline text-indigo-800 text-xs font-medium py-1 px-3 rounded-full mt-2 truncate"
      >
        {course.course_address}
      </a>
    );
  } else if (course.course_county) {
    return (
      <Link
        to={`/lists/golf-courses/county-ranking/${slugify(
          course.course_county,
        )}`}
        className="inline-block bg-indigo-100 hover:bg-indigo-600 hover:text-white no-underline text-indigo-800 text-xs font-medium py-1 px-3 rounded-full mt-2 truncate"
      >
        {course.course_county}
      </Link>
    );
  }
};

function GolfCourseHeader({ course }) {
  return (
    <section
      id="search"
      className="lg:h-[185px] mx-auto bg-white w-full p-4 mt-1 rounded-lg shadow-lg"
    >
      <h1 className="text-3xl font-bold text-gray-800">{course.course_name}</h1>

      {course.linked_golf_clubs && course.linked_golf_clubs.length > 0 && (
        <div className="mt-2 flex flex-row flex-wrap gap-2">
          {course.linked_golf_clubs.map((club, index) => (
            <Link
              key={index}
              to={`/lists/golf-clubs/${slugify(club)}`}
              className="inline-block bg-green-100 hover:bg-green-600 hover:text-white no-underline text-green-800 text-xs font-medium py-1 px-3 rounded-full"
            >
              {club}
            </Link>
          ))}
        </div>
      )}

      <p className="mt-2 text-sm text-gray-600 truncate">
        {renderAddressOrCounty(course)}
      </p>

      <div className="mt-3 pl-2 flex flex-row items-center gap-4 border-t border-gray-200 pt-2">
        <a
          href={course.club_website ? course.club_website : undefined}
          target={course.club_website ? '_blank' : undefined}
          rel={course.club_website ? 'noopener noreferrer' : undefined}
          className={
            course.club_website
              ? 'text-sm text-blue-600 hover:underline'
              : 'text-sm text-gray-400 hover:cursor-not-allowed'
          }
        >
          {course.club_website ? 'Website' : 'Website'}
        </a>
        <a
          href={
            course.office_email ? `mailto:${course.office_email}` : undefined
          }
          className={
            course.office_email
              ? 'text-sm text-blue-600 hover:underline'
              : 'text-sm text-gray-400 hover:cursor-not-allowed'
          }
        >
          {course.office_email ? 'Email' : 'Email'}
        </a>
        <p
          className={
            course.office_phone
              ? 'text-sm text-blue-600 hover:underline cursor-pointer'
              : 'text-sm text-gray-400 hover:cursor-not-allowed'
          }
          onClick={() => {
            if (course.office_phone) copyToClipboard(course.office_phone);
          }}
          title="Click to copy phone number"
        >
          {course.office_phone ? course.office_phone : 'Phone'}
        </p>
      </div>
    </section>
  );
}

export default GolfCourseHeader;
